import script from "./PoliticaRepasse.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaRepasse.vue?vue&type=script&setup=true&lang=js"

import "@/assets/legal.css?vue&type=style&index=0&id=13171547&scoped=true&lang=css&external"
import "./PoliticaRepasse.vue?vue&type=style&index=1&id=13171547&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13171547"]])

export default __exports__